/**
 * Sedes de referencia — modo "Red nacional CALE".
 *
 * Estados del ciclo de vida de una sede en la simulación:
 * - candidata: anteproyecto de referencia [DISEÑO]. NUNCA afirmar habilitación.
 * - declarada: existe manifestación pública/institucional [POR VERIFICAR].
 * - verificada: confirmada contra fuente primaria [EVIDENCIA].
 *
 * La única sede precargada es el anteproyecto de referencia de Envigado
 * (Institución Universitaria de Envigado), en estado 'candidata' [DISEÑO]:
 * es material educativo de anteproyecto, no una afirmación de registro
 * RUNT ni de habilitación CALE.
 *
 * Carga de sedes adicionales: cuando exista base oficial (listado RUNT de
 * CALE registrados), se cargará desde esa fuente con DataMeta { fuente,
 * fechaCorte, hashArchivo } y estado inicial 'declarada' hasta verificación
 * contra acto administrativo. Mientras tanto, SEDES_ADICIONALES permanece
 * vacío a propósito — no se inventan sedes.
 */
export type SedeEstado = "candidata" | "declarada" | "verificada";

export interface Sede {
  id: string;
  nombre: string;
  /** Código DIVIPOLA del municipio anfitrión. */
  codigoMunicipio: string;
  municipio: string;
  departamento: string;
  lat: number;
  lon: number;
  estado: SedeEstado;
  /** Institución proponente (solo anteproyecto de referencia). */
  proponente?: string;
  nota: string;
}

export const SEDE_REFERENCIA_ENVIGADO: Sede = {
  id: "SEDE-REF-ENVIGADO",
  nombre: "Anteproyecto CALE de referencia — Envigado",
  codigoMunicipio: "05266",
  municipio: "Envigado",
  departamento: "Antioquia",
  lat: 6.17,
  lon: -75.583,
  estado: "candidata",
  proponente: "Institución Universitaria de Envigado (IUE)",
  nota:
    "[DISEÑO] Anteproyecto de referencia para la experiencia 3D educativa. " +
    "NO afirma habilitación, registro RUNT ni entrada en operación. " +
    "El esquema CALE está suspendido a la fecha de corte (Circular Ext. 20261010000317 de 2026).",
};

/** Vacío intencionalmente: las sedes reales se cargarán desde base oficial verificada. */
export const SEDES_ADICIONALES: readonly Sede[] = [];

export const SEDES: readonly Sede[] = [SEDE_REFERENCIA_ENVIGADO, ...SEDES_ADICIONALES];
